import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';
import 'react-datepicker/dist/react-datepicker.min.css';
import DatePicker from 'react-datepicker';
import moment from 'moment';

class UsersFilterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: [
        { title: 'User', type: 'provider', name: 'provider' },
        { title: 'From', type: 'date', name: 'from' },
        { title: 'To', type: 'date', name: 'to' },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  onProviderFilterChange(val) {
    this.props.change('provider', val);
    //setTimeout(() => this.props.handleSubmit(this.submit)(), 0);
  }

  renderDatepicker = ({
    input,
    options,
    label,
    selected,
    isMulti,
    meta: { touched, error, warning },
  }) => {
    return (
      <div className="filter datepicker">
        <span className="title">
          {label}
          {`: `}
        </span>
        <DatePicker
          dateFormat="yyyy-MM-dd"
          selected={input.value || null}
          onChange={e => this.handleChange(e, input.name)}
        />
      </div>
    );
  };

  handleChange(date, field) {
    if (field) {
      this.props.change(field, date);
      //setTimeout(() => this.props.handleSubmit(this.submit)(), 0);
    }
  }

  renderProvider = ({
    input,
    options,
    label,
    selected,
    isMulti,
    meta: { touched, error, warning },
  }) => (
    <div className="filter provider">
      <span className="title">
        {label}
        {`: `}
      </span>
      <AsyncSelect
        isMulti={this.props.isMulti}
        cacheOptions
        defaultOptions
        loadOptions={this.searchUsers}
        getOptionValue={option => option.id}
        getOptionLabel={option => option.name}
        placeholder="Select User…"
        styles={{
          control: styles => ({
            ...styles,
            borderColor: 'transparent',
            border: 'none',
            borderWidth: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            minHeight: 22,
            minWidth: 160,
          }),
          dropdownIndicator: styles => ({
            ...styles,
            padding: 2,
          }),
          clearIndicator: styles => ({
            ...styles,
            padding: 2,
          }),
          menu: styles => ({
            ...styles,
            zIndex: 99,
            color: '#108ee9'
          }),
        }}
        menuPlacement="top"
        onChange={this.onProviderFilterChange.bind(this)}
      />
    </div>
  );

  searchUsers = search => {
    return this.props.searchUsers(search, 'isActive');
  };

  submit = vals => {
    const { onSubmit } = this.props;
    const values = { ...vals };

    if (values.provider !== undefined) {
      if (values.provider.length > 0) {
        values.provider = values.provider.map(el => el.code);
      }
    }

    if (values.from) {
      values.from = moment(values.from).format('YYYY-MM-DD');
    }
    if (values.to) {
      values.to = moment(values.to).format('YYYY-MM-DD');
    }
    return onSubmit({ ...values });

  };

  render() {
    const { handleSubmit } = this.props;
    const { filters } = this.state;

    return (
      <form onSubmit={handleSubmit(this.submit)} className="telemetry-filters">
        {filters &&
          filters.map((item, i) => {
            if (item.type && item.type === 'provider') {
              return (
                <Field
                  name={item.name}
                  className="form-control"
                  component={this.renderProvider}
                  key={i}
                  label={item.title}
                />
              );
            }
            if (item.type && item.type === 'date') {
              return (
                <Field
                  name={item.name}
                  className="form-control"
                  component={this.renderDatepicker}
                  key={i}
                  label={item.title}
                />
              );
            }

            return (
              <div className="filter" key={i}>
                <span className="title">{item.title}</span>
              </div>
            );
          })}
        <button type="submit" className="btn btn-sm btn-primary pull-right">
          View Log
        </button>
      </form>
    );
  }
}
const validate = (values, props) => {
  const errors = {};

  return errors;
};

UsersFilterForm = connect(state => ({
  initialValues: {},
  validate: validate,
}))(reduxForm({ form: 'usersFilterForm' })(UsersFilterForm));
export default UsersFilterForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/UsersFilterForm.js